@if(showLoginButtons){
<div class="login-box">
	@if(juniverseEnabled) {
	<input
		class="button"
		type="submit"
		value="{{ partner }}"
		(click)="loginJuniverse()"
	/>
	}
	<input
		class="button"
		type="submit"
		value="{{ users }}"
		(click)="loginJnJ()"
	/>
</div>
}
